enum Camera {
  SMALL = 'small',
  LARGE = 'large',
}

export { Camera };
